import { useState } from 'react';
import { AnswerOption, AnswerQuestion, AnswerContext } from '../../types/data';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { createAnswerRequestVPO, updateAnswerRequestVPO } from '../../store/data-main/data-main';
import AddButton from '../add-button/add-button';
import { lock } from '../../ui-icons/icons';
import { selectCurrentUser } from 'src/modules/users/selector';

type QuestionType = {
  data: AnswerQuestion;
  requirementId: number;
  requirementTitle?: string;
  blockId?: number;
  blockTitle?: string;
  processId?: number;
  processTitle?: string;
  isCompleted: boolean;
  answerContext: AnswerContext & {requirementId: number;};
  onCreateQuestionnaire: () => void;
  context?: any;
};

function Question(props: QuestionType) {
  const { data, requirementId, requirementTitle, blockId, blockTitle, processId, processTitle, isCompleted, answerContext, onCreateQuestionnaire, context } = props;
  const [active, setActive] = useState<boolean>(false);
  const [question, setQuestion] = useState<AnswerOption>(data.answer);

  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(selectCurrentUser);
  const canViewAudit = currentUser?.infoVPO?.zone || currentUser?.infoVPO?.adminRegion;

  //! Блокировка ответа, но действия добавлять можно
  const isAnswerLocked = data.isAudit && !canViewAudit;

  const questionArray: AnswerOption[] = answerContext.isEditNA ? ['Да', 'Нет', 'N/A'] : ['Да', 'Нет'];

  const filterQuestion = questionArray.filter((el) => el !== question);


  console.log('answerQuestion', question);

  //! для AddButton
  const predefinedValues = {
    group: context?.group ? { id: context.group.id, name: context.group.name } : null,
    factory: context?.factory ? { id: context.factory.id, name: context.factory.name } : null,
    column: context?.currentColumn ? { id: context.currentColumn.id, name: context.currentColumn.title } : null,
    columnBlock: blockId && blockTitle ? { id: blockId, name: blockTitle } : null,
    subdivision: { id: data.departmentId, name: data.department },
    demand: requirementId && requirementTitle ? {
      id: requirementId,
      name: requirementTitle,
      process: processId && processTitle ? { id: processId, title: processTitle } : null
    } : null,
    process: processId && processTitle ? { id: processId, name: processTitle } : null,
  };

  const handleChangeQuestion = (newAnswer: AnswerOption) => {
    if (data.answerId === null) {
      dispatch(createAnswerRequestVPO({
        Condition: newAnswer,
        Factory: answerContext.factory,
        Subdivision: data.departmentId,
        Month: answerContext.month,
        Year: answerContext.year,
        Requirement: answerContext.requirementId,
        Group: answerContext.group,
        Column: answerContext.column
      }));
    } else {
      dispatch(updateAnswerRequestVPO({
        id: data.answerId,
        Condition: newAnswer
      }));
    }
  };

  if (data.noRender) {
    return;
  }

  if (question === 'N/A' && !answerContext.isEditNA ) {
    return (
      <div
            className='inline-flex w-full items-center gap-2 text-center pointer-events-none opacity-75'
      >
        <div
          className="relative w-[48px] grow cursor-pointer rounded-sm border px-2 py-1 hover:border-[#8899A8] bg-white"
        >
          <span className='text-black'>{question}</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`inline-flex w-full items-center gap-2 text-center`}
    >
      <div
        className={`relative w-[48px] grow rounded-sm border px-2 py-1 bg-white ${
          (isCompleted || isAnswerLocked) ? 'pointer-events-none' : 'cursor-pointer hover:border-[#8899A8]'
        }`}
        onClick={() => !isCompleted && !isAnswerLocked && setActive((prev) => !prev)}
      >
        <span className='text-black'>{question}</span>

        {active && !isCompleted && !isAnswerLocked && (
          <ul className="absolute left-[-1px] right-[-1px] top-[calc(100%+2px)] z-10 flex flex-col gap-0.5">
            {filterQuestion.map((el, index) => {
              console.log('questionEl', el)
              return (
                <li
                  className="cursor-pointer rounded-sm border bg-white px-2 py-1 hover:border-[#8899A8]"
                  key={index}
                  onClick={() => {
                    setQuestion(el);
                    setActive(true);
                    handleChangeQuestion(el);
                    onCreateQuestionnaire();
                  }}
                >
                  {el}
                </li>
              )
            })}
          </ul>
        )}
      </div>
      {question !== 'N/A' && (
        <AddButton
          answer={question}
          actions={data.actions}
          context={context}
          predefinedValues={predefinedValues}
          isAudit={data.isAudit}
          answerId={data.answerId}
        />
      )}
    </div>
  );
}

export default Question;
